import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

function get ({requestUrl, cacheControl, returnRequestUrlOnly} = {})
{
    let url = urljoin(ServicesUtils.apiUrl, 'request-relay')
    const options = { methid: 'get', url, params: {requestUrl, cacheControl} }
    const relayUrl = axios.getUri(options)

    if (returnRequestUrlOnly) return relayUrl

    return  axios.get(relayUrl)
}

export default { get }


// WEBPACK FOOTER //
// ./src/services/requestRelay.js